export const ProcessingTimeType: Record<string, string> = {
  Instant: "Instant",
  "1-2 Business Days": "1-2 Business Days",
  "3-5 Business Days": "3-5 Business Days",
  "5+ Business Days": "5+ Business Days"
};
